// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./pageLoader.module.scss";

function PageLoader() {
    const { t } = useTranslation("common");
    return (
        <div className={styles.wrapper} role="status" aria-live="polite">
            <span className={styles.spinner} />
            <span className={styles.srOnly}>{t("pageLoader.loading")}</span>
        </div>
    );
}

export default PageLoader;
